import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Card = styled(Link)`
  border-radius: 20px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border: none;
  transition: all 0.3s ease;
  background: white;
  
  /* Smooth hover animation */
  &:hover {
    transform: translateY(-5px) scale(1.05);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
  }
  
  /* Gentle active state */
  &:active {
    transform: translateY(-2px) scale(1.02);
    transition: all 0.1s ease;
  }

  color: white;
  text-decoration: none;
  position: relative;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
`;

const CardStatic = styled.div`
  border-radius: 20px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border: none;
  background: white;
  position: relative;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin-bottom: 2rem;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  
  @media (max-width: 768px) {
    max-width: 350px;
  }
`;

const CategoryImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 8px;
  z-index: 1;
`;

function CategoryCard({ to, image, alt, isStatic = false }) {
  if (isStatic) {
    return (
      <CardStatic>
        <CategoryImage src={image} alt={alt} />
      </CardStatic>
    );
  }

  return (
    <Card to={to}>
      <CategoryImage src={image} alt={alt} />
    </Card>
  );
}

export default CategoryCard;

